// src/components/DashboardLayout.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./PayrollConnect.css";
import Sidebar from "../../Layout/Sidebar";
import Topbar from "../../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../../contexts/ToastContext";
import { apiRequest } from "../../../services/api";
import Loader from "../../Common/Loader";
import { Card, Breadcrumb } from "react-bootstrap";
import { encryptData } from "../../Common/encryptionUtils";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { AccessLog } from "../../../Utils/AccessLog";
import DropAndDropImage from "../../../assets/draganddrop.png";
import RightArrrowImage from "../../../assets/rightArrow.jpg";
import {
  Button,
  MenuItem,
  Select,
  Box,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TableHead,
} from "@mui/material";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const PayrollConnect = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };

  useEffect(() => {
    // AccessLog("Payroll Configuration");
  }, []);

  const premiseData = (data) => {};

  const authToken = localStorage.getItem("authToken");

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [confirmMapDialogOpen, setConfirmMapDialogOpen] = useState(false);

  const handleConfirmPopUpOpen = () => {
    setConfirmDialogOpen(true);
  };

  const handleDisconnectCancel = () => {
    setConfirmDialogOpen(false);
  };

  const createEmployeeMappingData = async () => {
    setConfirmMapDialogOpen(false);

    if (connectedDetails?.platform === "QuickBooks") {
      await createQuickbooksEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Zoho") {
      await createZohoEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Gusto") {
      await createGustoEmployeeMapping(mappedUsers);
    }
  };

  const handleCancelMapping = () => {
    setConfirmMapDialogOpen(false);
  };

  // const Title = "Settings";

  const { toastMessage, clearToast } = useToast();
  const [userList, setUserList] = useState([]);
  const [connectedDetails, setConnectedDetails] = useState(null);
  const [platformEmployeeDetails, setPlatformEmployeeDetails] = useState(null);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const [status, setStatus] = useState(null);
  const [selectedOption, setSelectedOption] = useState(
    window.location.hostname == "web.businesstime.us" ||
      window.location.hostname == "webgamma.businesstime.us"
      ? "QuickBooks"
      : "Zoho"
  );
  const [error, setError] = useState("");

  // Check redirect callback
  useEffect(() => {
    checkConnectedStatus();
  }, []);

  // Check redirect callback
  // useEffect(() => {
  //   if (!connectedDetails) return;
  //   console.log("connectedDetails?.platform-->", connectedDetails?.platform);
  //   if (connectedDetails?.platform == "QuickBooks") {
  //     getEmployess();
  //     fetchMappedUsers(selectedPremise?.value);
  //   } else {
  //     getZohoEmployess();
  //   }
  //   fetchAlluser(selectedPremise?.value);
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const statusParam = urlParams.get("status");
  //   // if (statusParam === "success") {
  //   //   setStatus("Connected Successfully ✅");
  //   // }
  // }, [connectedDetails]);

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  const checkConnectedStatus = async () => {
    pageLoading(true);
    try {
      const headers = { Authorization: `Bearer ${authToken}` };
      const policyResponse = await apiRequest(
        `web_api/admin/payroll/status?customer_account_id=${customerDetails?.customerAccountId}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse.data?.data
      ) {
        const customer_details = policyResponse.data.data;
        setConnectedDetails(customer_details);

        // Call dependent APIs here, after state update
        if (customer_details.platform === "QuickBooks") {
          getEmployess();
          fetchMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Zoho") {
          getZohoEmployess();
          fetchZohoMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Gusto") {
          getGustoEmployess();
          fetchGustoMappedUsers(selectedPremise?.value);
        }
        fetchAlluser(selectedPremise?.value);
      } else {
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, { position: "top-right", autoClose: 4000 });
    } finally {
      pageLoading(false);
    }
  };

  console.log("selectedOption---->", selectedOption);

  const handleConnect = () => {
    if (!selectedOption) {
      setError("Please select a payroll software to connect.");
      return;
    }
    setError("");
    if (selectedOption == "QuickBooks") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/intuit/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/intuit/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    } else if (selectedOption == "Gusto") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/gusto/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/gusto/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    } else if (selectedOption == "Zoho") {
      if (window.location.hostname == "web.businesstime.us") {
        window.location.href = `https://businesstime.us/businesstime_api/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "web.businesstime.app") {
        window.location.href = `https://businesstime.app/businesstime_api/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "webgamma.businesstime.us") {
        window.location.href = `https://businesstime.us/business-i_backend_uat/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      } else if (window.location.hostname == "webgamma.businesstime.app") {
        window.location.href = `https://businesstime.app/business-i_backend_uat/public/web_api/admin/zoho/connect?customer_account_id=${customerDetails?.customerAccountId}`;
      }
    }
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      pageLoading(true);
      if (connectedDetails?.platform === "QuickBooks") {
        fetchMappedUsers(selected?.value);
      } else if (connectedDetails?.platform === "Zoho") {
        fetchZohoMappedUsers(selected?.value);
      } else if (connectedDetails?.platform === "Gusto") {
        fetchGustoMappedUsers(selected?.value);
      }

      fetchAlluser(selected.value);
      setSelectedPremise(selected);
    }
  };

  const handleDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectQuickBooksPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleZohoDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectZohoPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGustoDisconnectConfirm = async () => {
    setConfirmDialogOpen(false);
    // Call your deactivation API here
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/disconnectGustoPayrollService",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setStatus("disconnect");
        const handleFetchAndToast = async () => {
          window.location.reload();
          // Step 2: Show success message after 1 second delay
          setTimeout(() => {
            toast.success(apiResponse.data.message, {
              position: "top-right",
              autoClose: 4000,
            });
          }, 500);
        };

        // Call the async function
        handleFetchAndToast();
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const getEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/getEmployeesFromPayrollService?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getZohoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchZohoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getGustoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchGustoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setOriginalUsers1(customer_details);
        setPlatformEmployeeDetails(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchAlluser = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getstaffdetailsbypremise?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.staffdetails
      ) {
        const user_details = userResponse.data?.data?.staffdetails;
        setSelectedUsers(user_details);
        setSelectedUsers1(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchQuickbooksMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        console.log("user_details--->", user_details);
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchZohoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchZohoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchGustoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchGustoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const reorderSelectedUsers = (alreadyMappedUsers, selectedUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return selectedUsers; // no reorder needed
    }
    console.log("ReOrder");
    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(selectedUsers.map((u) => [u.user_id, u]));

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(mapped.user_id)) // get from selectedUsers
      .filter((u) => u !== undefined); // remove if not found

    // Append unmapped users at the end (optional)
    const unmapped = selectedUsers.filter(
      (u) => !alreadyMappedUsers.some((mapped) => mapped.user_id === u.user_id)
    );

    return [...reordered, ...unmapped];
  };

  const reorderOriginalUsers = (alreadyMappedUsers, originalUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return originalUsers; // no reorder needed
    }

    // Detect key based on platform
    const getOriginalKey = (u) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return u.Id;
        case "Zoho":
          return u["Employee ID"]; // ✅ fixed: use "Employee ID"
        case "Gusto":
          return u.uuid; // ✅ use uuid (as per mergedUsers code)
        default:
          return u.uuid; // fallback
      }
    };

    const getMappedKey = (mapped) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return mapped.qb_employee_id;
        case "Zoho":
          return mapped.zoho_employee_id;
        case "Gusto":
          return mapped.gusto_employee_id;
        default:
          return mapped.gusto_employee_id; // fallback
      }
    };

    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(
      originalUsers.map((u) => [getOriginalKey(u), u])
    );

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(getMappedKey(mapped)))
      .filter((u) => u !== undefined);

    // Append unmapped users at the end
    const unmapped = originalUsers.filter(
      (u) =>
        !alreadyMappedUsers.some(
          (mapped) => getMappedKey(mapped) === getOriginalKey(u)
        )
    );

    return [...reordered, ...unmapped];
  };

  console.log("statusstatus--->", status);

  const [open, setOpen] = useState(false);

  const [originalUsers, setOriginalUsers] = useState([]);
  const [originalUsers1, setOriginalUsers1] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsers1, setSelectedUsers1] = useState([]);

  const [alreadyMappedUsers, setAlreadyMappedUsers] = useState([]);

  console.log("originalUsers--->", originalUsers);

  console.log("selectedUsers--->", selectedUsers);

  // Handle reordering
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;

    if (source.droppableId === destination.droppableId) {
      // Reorder in same table
      if (source.droppableId === "original") {
        const items = Array.from(originalUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setOriginalUsers(items);
      } else {
        const items = Array.from(selectedUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setSelectedUsers(items);
      }
    }

    setSubmitMessage("");
    setIsSuccess(null);
  };

  const [submitMessage, setSubmitMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [mappedUsers, setMappedUsers] = useState([]);

  console.log("connectedDetails--->", connectedDetails);

  // const handleSubmit = (values) => {
  //   // Build merged array (include all, even if unmatched)
  //   const mergedUsers = selectedUsers
  //     .slice(0, originalUsers.length) // ensure same count
  //     .map((selected, i) => {
  //       if (!selected || !originalUsers[i]) return null;

  //       const full_name = `${selected.first_name} ${selected.last_name}`;
  //       const original_full_name =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Name
  //           : `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
  //       const employee_id =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Id
  //           : originalUsers[i]["Employee ID"];
  //       const originalNameFirstWord = (original_full_name || "").split(" ")[0];
  //       const selectedNameFirstWord = full_name.split(" ")[0] || "";

  //       const isMatch = originalNameFirstWord === selectedNameFirstWord;

  //       return {
  //         user_id: selected.user_id, // from selected
  //         staff_id: selected.staff_id, // from selected
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_id"
  //           : "zoho_employee_id"]: employee_id, // from original
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_name"
  //           : "zoho_employee_name"]: original_full_name, // from original
  //         matched: isMatch, // extra flag (optional, useful for UI/debug)
  //       };
  //     })
  //     .filter(Boolean);

  //   // Check if all matched
  //   const allMatched = mergedUsers.every((u) => u.matched);

  //   if (allMatched) {
  //     setSubmitMessage("✅ All selected employees match the original order");
  //     setIsSuccess(true);
  //     setMappedUsers(mergedUsers);
  //     connectedDetails?.platform === "QuickBooks"
  //       ? createQuickbooksEmployeeMapping(mergedUsers)
  //       : createZohoEmployeeMapping(mergedUsers);
  //   } else {
  //     console.log("originalUsersNotMatch--->", originalUsers);
  //     console.log("selectedUsersNotMatch--->", selectedUsers);
  //     console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
  //     setMappedUsers(mergedUsers);
  //     setConfirmMapDialogOpen(true);
  //     setIsSuccess(false);
  //   }

  //   // 👉 Console final flat array
  //   console.log("Final merged Users:", mergedUsers);
  // };

  const handleSubmit = (values) => {
    // Build merged array (include all, even if unmatched)
    const mergedUsers = selectedUsers
      .slice(0, originalUsers.length) // ensure same count
      .map((selected, i) => {
        if (!selected || !originalUsers[i]) return null;

        const full_name = `${selected.first_name} ${selected.last_name}`;

        // 🔑 Handle platform-specific fields
        let original_full_name = "";
        let employee_id = "";

        if (connectedDetails?.platform === "QuickBooks") {
          original_full_name = originalUsers[i].Name;
          employee_id = originalUsers[i].Id;
        } else if (connectedDetails?.platform === "Zoho") {
          original_full_name = `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
          employee_id = originalUsers[i]["Employee ID"];
        } else if (connectedDetails?.platform === "Gusto") {
          original_full_name =
            originalUsers[i].first_name + " " + originalUsers[i].last_name;
          employee_id = originalUsers[i].uuid; // Gusto employees have `id`
        }

        const originalNameFirstWord = (original_full_name || "").split(" ")[0];
        const selectedNameFirstWord = full_name.split(" ")[0] || "";

        const isMatch = originalNameFirstWord === selectedNameFirstWord;

        // Return common structure with platform-specific IDs
        return {
          user_id: selected.user_id, // from selected
          staff_id: selected.staff_id, // from selected

          // ✅ Dynamic key assignment based on platform
          ...(connectedDetails?.platform === "QuickBooks" && {
            qb_employee_id: employee_id,
            qb_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Zoho" && {
            zoho_employee_id: employee_id,
            zoho_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Gusto" && {
            gusto_employee_id: employee_id,
            gusto_employee_name: original_full_name,
            gusto_job_id: originalUsers[i].jobs[0].uuid,
            company_uuid: originalUsers[i].company_uuid,
          }),

          matched: isMatch, // extra flag (optional, useful for UI/debug)
        };
      })
      .filter(Boolean);

    // Check if all matched
    const allMatched = mergedUsers.every((u) => u.matched);

    if (allMatched) {
      setSubmitMessage("✅ All selected employees match the original order");
      setIsSuccess(true);
      setMappedUsers(mergedUsers);

      // 👉 Trigger respective API
      if (connectedDetails?.platform === "QuickBooks") {
        createQuickbooksEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Zoho") {
        createZohoEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Gusto") {
        console.log("originalUsersNotMatch--->", originalUsers);
        createGustoEmployeeMapping(mergedUsers);
      }
    } else {
      console.log("originalUsersNotMatch--->", originalUsers);
      console.log("selectedUsersNotMatch--->", selectedUsers);
      console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
      setMappedUsers(mergedUsers);
      setConfirmMapDialogOpen(true);
      setIsSuccess(false);
    }

    // 👉 Console final flat array
    console.log("Final merged Users:", mergedUsers);
  };

  const createQuickbooksEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createQuickbooksEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createZohoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createZohoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createGustoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createGustoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        toast.success(apiResponse.data.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (alreadyMappedUsers?.length > 0) {
      console.log("user_detailsData--->", alreadyMappedUsers);
      const newOrder = reorderSelectedUsers(alreadyMappedUsers, selectedUsers);
      const newOriginalOrder = reorderOriginalUsers(
        alreadyMappedUsers,
        originalUsers
      );
      console.log("newOriginalOrder--->", newOriginalOrder);
      setSelectedUsers(newOrder);
      setOriginalUsers(newOriginalOrder);
    }
  }, [alreadyMappedUsers, selectedUsers1, originalUsers1]);

  // const handleSubmit = () => {
  //   // Filter only mapped employees
  //   const mappedEmployees = selectedUsers.filter((selected, i) => {
  //     if (!selected || !originalUsers[i]) return false; // ✅ protect against undefined

  //     const full_name = `${selected.first_name} ${selected.last_name}`;
  //     const originalNameFirstWord = (originalUsers[i].Name || "").split(" ")[0];
  //     const selectedNameFirstWord = full_name.split(" ")[0] || "";

  //     return originalNameFirstWord === selectedNameFirstWord;
  //   });

  //   // Check if all employees are matched
  //   if (mappedEmployees.length === originalUsers.length) {
  //     setSubmitMessage("✅ All selected employees match the original order");
  //     setIsSuccess(true);
  //   } else {
  //     setSubmitMessage(
  //       "❌ BusinessTime employees are not in the same order as QuickBooks employees."
  //     );
  //     setIsSuccess(false);
  //   }

  //   // 👉 Console the new array without unmapped employees
  //   console.log("Mapped Employees:", mappedEmployees);
  // };

  console.log("selectedUsers---->", selectedUsers);
  console.log("alreadyMappedUsers--->", alreadyMappedUsers);

  const arrowLength = Math.min(selectedUsers?.length, originalUsers?.length);

  console.log("arrowLength--->", arrowLength);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-between pb-3">
            <div className="contentDiv">
              {/* <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>{Title}</Breadcrumb.Item>
                <Breadcrumb.Item active>Time Off Configuration</Breadcrumb.Item>
              </Breadcrumb> */}
              {/* <span className="contentTitle">Report</span> */}
              {/* <span className='contentTitle'>{Title}</span> */}
            </div>
            {/* Search bar on the same row */}
          </div>
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="row mt-0 g-4">
                <div style={{ textAlign: "center", margin: "0px" }}>
                  {connectedDetails?.customer_account_id ? (
                    <Box
                      sx={{
                        padding: 3,
                        borderRadius: 2,
                        background: "#fff",
                        color: "#000",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                        maxWidth: 1000,
                        mx: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: "wrap",
                          gap: 3,
                        }}
                      >
                        {/* Connected Time */}
                        <Box
                          sx={{
                            flex: "1 1 200px",
                            minWidth: { xs: "100%", sm: "200px" }, // full width on xs, normal on sm+
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600 }}
                          >
                            Connected Time
                          </Typography>
                          <Typography variant="body2">
                            {connectedDetails?.created_at}
                          </Typography>
                        </Box>

                        {/* Platform */}
                        <Box
                          sx={{
                            flex: "1 1 120px",
                            minWidth: { xs: "100%", sm: "120px" },
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600 }}
                          >
                            Platform
                          </Typography>
                          <Typography variant="body2">
                            {connectedDetails?.platform}
                          </Typography>
                        </Box>

                        {/* Status */}
                        <Box
                          sx={{
                            flex: "0 1 200px",
                            minWidth: { xs: "100%", sm: "200px" },
                            mr: { sm: "40px", xs: 0 }, // margin only on bigger screens
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600 }}
                          >
                            Status
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: "green", fontWeight: 600 }}
                          >
                            Connected
                          </Typography>
                        </Box>

                        {/* Action buttons */}
                        <Box
                          sx={{
                            flex: "1 1 200px",
                            minWidth: { xs: "100%", sm: "200px" },
                          }}
                        >
                          <Box sx={{ flex: "1 1 200px" }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 1,
                                mt: 0.5,
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ borderRadius: 1, textTransform: "none" }}
                                onClick={() => setOpen(true)}
                              >
                                Map Employee
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ borderRadius: 1, textTransform: "none" }}
                                onClick={handleConfirmPopUpOpen}
                              >
                                Disconnect
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        padding: 3,
                        borderRadius: 2,
                        background: "#fff", // same as Connected Info
                        color: "#000",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                        maxWidth: 1000,
                        mx: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: "wrap", // mobile responsive
                          gap: 3,
                          alignItems: "center",
                        }}
                      >
                        {/* Title */}
                        <Box sx={{ flex: "1 1 300px" }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 600 }}
                          >
                            Please choose the payroll software you’d like to
                            integrate.
                          </Typography>
                        </Box>

                        {/* Dropdown + Error */}
                        <Box sx={{ flex: "1 1 300px" }}>
                          <Select
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            sx={{
                              minWidth: 200,
                              backgroundColor: "#f9f9f9",
                              borderRadius: 1,
                              "& .MuiSelect-select": { padding: "10px 14px" },
                            }}
                          >
                            {[
                              "web.businesstime.us",
                              "webgamma.businesstime.us",
                              "localhost",
                            ].includes(window.location.hostname) && (
                              <MenuItem value="QuickBooks">QuickBooks</MenuItem>
                            )}

                            {[
                              "web.businesstime.us",
                              "webgamma.businesstime.us",
                              "localhost",
                            ].includes(window.location.hostname) && (
                              <MenuItem value="Gusto">Gusto</MenuItem>
                            )}

                            <MenuItem value="Zoho">Zoho</MenuItem>
                          </Select>

                          {error && (
                            <Typography
                              sx={{
                                color: "red",
                                fontSize: "14px",
                                fontWeight: 500,
                                mt: 0.5, // spacing below select
                              }}
                            >
                              {error}
                            </Typography>
                          )}
                        </Box>

                        {/* Action Button */}
                        <Box sx={{ flex: "1 1 200px", textAlign: "right" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{
                              padding: "8px 20px",
                              fontWeight: 600,
                              borderRadius: 1,
                              textTransform: "none",
                              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                            onClick={handleConnect}
                          >
                            Connect
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  <Dialog open={confirmDialogOpen}>
                    <DialogTitle
                      sx={{
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        padding: "10px 24px",
                        fontSize: "1.1rem",
                      }}
                    >
                      Confirm Platform Disconnect
                    </DialogTitle>
                    <DialogContent dividers>
                      <Typography variant="body2" color="textSecondary">
                        Are you sure you want to disconnect this platform?
                      </Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        className="btn btn-info policyCancel"
                        onClick={() => handleDisconnectCancel()}
                        style={{
                          background: "white",
                          color: "#2c81d6",
                          border: "none",
                          fontSize: "13px",
                        }}
                      >
                        CANCEL
                      </Button>
                      <Button
                        className="btn policyConfirmDeactive"
                        style={{
                          border: "none",
                          fontSize: "13px",
                          padding: "9px 18px",
                          borderRadius: "4px",
                          color: "white",
                        }}
                        onClick={() => {
                          if (connectedDetails?.platform === "QuickBooks") {
                            handleDisconnectConfirm();
                          } else if (connectedDetails?.platform === "Zoho") {
                            handleZohoDisconnectConfirm();
                          } else if (connectedDetails?.platform === "Gusto") {
                            handleGustoDisconnectConfirm();
                          }
                        }}
                      >
                        CONFIRM
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
              {connectedDetails?.customer_account_id && (
                <div className="row mt-0 g-4">
                  <Box>
                    {/* Popup Dialog */}

                    <Dialog open={open} maxWidth="lg" fullWidth>
                      <DialogTitle
                        sx={{
                          fontWeight: 600,
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        Map Employees
                      </DialogTitle>

                      {submitMessage && (
                        <p
                          style={{
                            color: isSuccess ? "green" : "red",
                            textAlign: "center",
                            marginTop: "-10px",
                            marginBottom: "0px",
                          }}
                        >
                          {submitMessage}
                        </p>
                      )}

                      <DialogContent
                        sx={{
                          overflowX: { xs: "auto", md: "hidden" }, // enable scroll on mobile
                          overflowY: "auto",
                          maxHeight: { xs: "80vh", md: "none" }, // limit height on mobile
                        }}
                      >
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Grid
                            container
                            spacing={4}
                            justifyContent="center"
                            alignItems="flex-start"
                            sx={{
                              flexWrap: { xs: "nowrap", md: "wrap" }, // stack without wrap on mobile
                              minWidth: { xs: "600px", md: "auto" }, // force scrollable width
                            }}
                          >
                            {/* Selected Users Table */}
                            <Grid
                              item
                              xs={12}
                              md={5}
                              sx={{
                                flex: "0 0 auto", // prevent flex growing/shrinking
                              }}
                            >
                              <Typography
                                variant="h6"
                                gutterBottom
                                sx={{ fontSize: "16px", fontWeight: "600" }}
                              >
                                Employee Names in BusinessTime
                              </Typography>
                              <Droppable droppableId="selected">
                                {(provided) => (
                                  <TableContainer
                                    component={Paper}
                                    sx={{
                                      boxShadow: 3,
                                      borderRadius: 2,
                                      // maxHeight: 400,
                                      // overflowY: "auto",
                                    }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    <Table stickyHeader>
                                      <TableBody>
                                        {selectedUsers.map((user, index) => (
                                          <Draggable
                                            key={`BU${user.user_id}`}
                                            draggableId={`BU${user.user_id}`}
                                            index={index}
                                          >
                                            {(provided, snapshot) => (
                                              <TableRow
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                sx={{
                                                  background:
                                                    snapshot.isDragging
                                                      ? "#e0f7fa"
                                                      : "white",
                                                  cursor: "grab",
                                                }}
                                              >
                                                <TableCell
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  {user?.first_name +
                                                    " " +
                                                    user?.last_name}
                                                  <span className="cursor-grab text-gray-400 ml-2">
                                                    <img
                                                      src={DropAndDropImage}
                                                      alt="drag"
                                                      width={20}
                                                      height={20}
                                                      className="w-4 h-4 inline-block"
                                                    />
                                                  </span>
                                                </TableCell>
                                              </TableRow>
                                            )}
                                          </Draggable>
                                        ))}
                                        {provided.placeholder}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}
                              </Droppable>
                            </Grid>

                            <Grid item xs={12} md={1}>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  marginTop: "30px",
                                }}
                              ></Typography>

                              <TableContainer
                                component={Paper}
                                sx={{
                                  boxShadow: "none", // remove shadow
                                  border: "none", // remove border
                                  borderRadius: 0, // reset radius
                                }}
                              >
                                <Table stickyHeader>
                                  <TableBody>
                                    {Array.from({ length: arrowLength }).map(
                                      (_, index) => (
                                        <TableRow
                                          sx={{
                                            background: "white",
                                          }}
                                        >
                                          <TableCell
                                            className="mappedArrowTd"
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              borderBottom:
                                                "1px solid white !important",
                                            }}
                                          >
                                            <span
                                              className="cursor-grab text-gray-400 ml-2"
                                              style={{ marginLeft: "5px" }}
                                            >
                                              <img
                                                src={RightArrrowImage}
                                                alt="drag"
                                                width={20}
                                                height={20}
                                                className="w-4 h-4 inline-block"
                                              />
                                            </span>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>

                            {/* Original Users Table */}
                            <Grid
                              item
                              xs={12}
                              md={5}
                              sx={{
                                flex: "0 0 auto", // prevent flex growing/shrinking
                              }}
                            >
                              <Typography
                                variant="h6"
                                gutterBottom
                                sx={{ fontSize: "16px", fontWeight: "600" }}
                              >
                                Employee Names in{" "}
                                {connectedDetails?.platform || "Platform"}{" "}
                              </Typography>
                              <Droppable droppableId="original">
                                {(provided) => (
                                  <TableContainer
                                    component={Paper}
                                    sx={{
                                      boxShadow: 3,
                                      borderRadius: 2,
                                      // maxHeight: 400,
                                      // overflowY: "auto",
                                    }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    <Table stickyHeader>
                                      {/* <TableHead>
                                        <TableRow>
                                          <TableCell
                                            sx={{ fontWeight: "bold" }}
                                          >
                                            Employee Name
                                          </TableCell>
                                        </TableRow>
                                      </TableHead> */}
                                      <TableBody>
                                        {originalUsers &&
                                        originalUsers.length > 0 ? (
                                          originalUsers.map((user, index) => {
                                            // Compute employeeKey and employeeName based on platform
                                            let employeeKey;
                                            let employeeName;

                                            switch (
                                              connectedDetails?.platform
                                            ) {
                                              case "Gusto":
                                                employeeKey = user.uuid; // or user.Id if needed
                                                employeeName = `${user.first_name} ${user.last_name}`;
                                                break;
                                              case "QuickBooks":
                                                employeeKey = user.Id;
                                                employeeName = user?.Name;
                                                break;
                                              case "Zoho":
                                                employeeKey =
                                                  user["Employee ID"];
                                                employeeName = `${user["First Name"]} ${user["Last Name"]}`;
                                                break;
                                              default:
                                                employeeKey = user.Id;
                                                employeeName = `${user["First Name"]} ${user["Last Name"]}`;
                                            }

                                            return (
                                              <Draggable
                                                key={`OR${employeeKey}`}
                                                draggableId={`OR${employeeKey}`}
                                                index={index}
                                              >
                                                {(provided, snapshot) => (
                                                  <TableRow
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    sx={{
                                                      background:
                                                        snapshot.isDragging
                                                          ? "#e0f7fa"
                                                          : "white",
                                                      cursor: "grab",
                                                    }}
                                                  >
                                                    <TableCell
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      {employeeName}
                                                      <span className="cursor-grab text-gray-400 ml-2">
                                                        <img
                                                          src={DropAndDropImage}
                                                          alt="drag"
                                                          width={20}
                                                          height={20}
                                                          className="w-4 h-4 inline-block"
                                                        />
                                                      </span>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              </Draggable>
                                            );
                                          })
                                        ) : (
                                          <TableRow>
                                            <TableCell
                                              colSpan={2}
                                              sx={{
                                                textAlign: "center",
                                                color: "gray",
                                                py: 2,
                                              }}
                                            >
                                              Employee not found
                                            </TableCell>
                                          </TableRow>
                                        )}

                                        {provided.placeholder}
                                        {/* Note Row */}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}
                              </Droppable>
                            </Grid>
                          </Grid>
                        </DragDropContext>

                        {/* Note */}
                        <Box
                          textAlign="center"
                          justifyContent="center"
                          mt={3}
                          className="NoteDivMapped"
                        >
                          <h6
                            style={{
                              backgroundColor: "#f9f9f9",
                              color: "gray",
                              padding: "5px 10px",
                              borderLeft: "4px solid #007bff",
                              fontSize: "12px",
                              fontWeight: "600",
                              marginBottom: "20px",
                              marginLeft: "10px",
                              width: "665px",
                              textAlign: "start",
                            }}
                          >
                            Note : <br />
                            1.
                            <span style={{ fontSize: "20px" }}> → </span> Mapped
                            to {connectedDetails?.platform}. <br />
                            2. Only employees that are mapped to{" "}
                            {connectedDetails?.platform} have been added.
                            Unmapped employees were skipped.
                          </h6>
                        </Box>

                        {/* Actions */}
                        <Box textAlign="center" mt={3}>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ mr: 2 }}
                            onClick={handleSubmit}
                            disabled={originalUsers.length === 0}
                          >
                            Submit
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setOpen(false);
                              setSubmitMessage("");
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </DialogContent>
                    </Dialog>

                    <Dialog open={confirmMapDialogOpen}>
                      <DialogTitle
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "#fff",
                          padding: "10px 24px",
                          fontSize: "1.1rem",
                        }}
                      >
                        Confirm
                      </DialogTitle>
                      <DialogContent dividers>
                        <Typography variant="body2" color="textSecondary">
                          The employee order in BusinessTime does not match{" "}
                          {connectedDetails?.platform}. Do you want to continue?
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          className="btn btn-info policyCancel"
                          onClick={() => handleCancelMapping()}
                          style={{
                            background: "white",
                            color: "#2c81d6",
                            border: "none",
                            fontSize: "13px",
                          }}
                        >
                          NO
                        </Button>
                        <Button
                          className="btn policyConfirmDeactive"
                          style={{
                            border: "none",
                            fontSize: "13px",
                            padding: "9px 18px",
                            borderRadius: "4px",
                            color: "white",
                          }}
                          onClick={() => {
                            createEmployeeMappingData();
                          }}
                        >
                          YES
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Box>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollConnect;
